import routeTypes from './route-types'
import store from '@/store'

const CountrySettingListView = (r) => require.ensure([], () => r(require('./CountrySettingListView.vue')), 'countrysettinglist-chunk')
const CountrySettingDetail = (r) => require.ensure([], () => r(require('./CountrySettingDetail.vue')), 'countrysetting-chunk')
const CountrySettingView = (r) => require.ensure([], () => r(require('./CountrySettingView.vue')), 'countrysetting-chunk')

const getStorage = function (query) {
  const sessionId = store.getters['userInfo/info'].sessionId
  return sessionStorage.getItem(`${sessionId}|countrysetting|${query}`)
}

const moduleId = 'A120'

export default [
  {
    path: routeTypes.CountrySettingListView.path,
    name: routeTypes.CountrySettingListView.name,
    component: CountrySettingListView,
    meta: {
      id: moduleId,
      route: 'listing',
      title: 'Country Setup',
      fkey: 'countrysetting|filter'
    }
  },
  {
    path: routeTypes.CountrySettingDetail.path,
    name: '',
    component: CountrySettingView,
    props: (route) => ({
      isNew: route.query.mode === 'new' || route.meta.isNew || getStorage('isNew') === 'true',
      returnUrl: route.query.returnUrl || route.meta.returnUrl || getStorage('returnUrl'),
      name: route.query.name || route.meta.name || getStorage('name')
    }),
    meta: {
      id: moduleId,
      route: 'detail',
      title: 'Country Setup'
    },
    query: {
      filter: ''
    },
    children: [
      {
        path: '',
        name: routeTypes.CountrySettingDetail.name,
        component: CountrySettingDetail,
        meta: {
          id: moduleId,
          title: 'Detail',
          fkey: 'countrysetting|filter'
        }
      }
    ]
  }
]
